import * as React from "react";
import Switch from "@mui/material/Switch";

export default function CustomSwitch({ checked, onChange }) {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      inputProps={{ "aria-label": "controlled" }}
      size="small"
    />
  );
}
